import { call } from "./api";
import { getCredentials } from "./session"
import config from "../config/app";
import AWS from 'aws-sdk';
import { v4 as uuidv4 } from 'uuid';
import path from 'path';

export const count = params => {
    return call(client => {
        return client.get(`/images/count`, params);
    });
};

export const all = () => {
    return call(client => {
        return client.get(`/images`, {
            params: { count: 0 }
        });
    });
};

export const search = params => {
    return call(client => {
        return client.get(`/images`, params);
    });
};

export const add = params => {
    const fileName = uuidv4() + path.extname(params.path);

    const postImage = client => {
        return client.post(`/images`, {
            path: fileName,
            name: params.name,
            sub: params.sub,
            username: params.username,
        });
    };

    let id;
    return call(postImage)
        .then(response => {
            id = response.data.id;
            return getCredentials()
        })
        .then(credentials => {
            const s3 = new AWS.S3({
                region: config.aws.region,
                credentials: credentials,
            });

            return s3.upload({
                Bucket: config.aws.s3.bucket,
                Body: params.body,
                Key: `images/${fileName}`
            }).promise();
        })
        .catch(err => {
            call(client => {
                return client.delete(`/images`, {
                    params: {
                        id: id
                    }
                })
            })
        })
};

export const edit = (id, params) => {
    return call(client => {
        return client.put(`/images/${id}`, params);
    });
};

export const remove = (id, path) => {
  return new Promise((resolve, reject) => {
      call(client => {
          return client.delete(`/images/${id}`, {});
      })
      .then(() => {
          return getCredentials();
      })
      .then(credentials => {
          const s3 = new AWS.S3({
              region: config.aws.region,
              credentials: credentials,
          });

          const params = {
              Bucket: config.aws.s3.bucket,
              Key: `images/${path}`
          };

          return s3.deleteObject(params).promise();
      })
      .then(() => {
          resolve();
      })
      .catch(err => {
          reject(err);
      })
  });
};

export const batchRemove = selectedItemInfo => {
    return Promise.all(selectedItemInfo.map(item => {
        return remove(item.id, item.path);
    }))
};



// WEBPACK FOOTER //
// ./src/api/image.js